import moment from 'moment';

export const suspensionDateStatus = {
  Future: 'Future',
  Ongoing: 'Ongoing',
  Expired: 'Expired',
};

export const defaultStartDate = moment().add(1, 'days');

export const parameterDateFormat = 'YYYY-MM-DD';
